import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { offlineEntries } from 'src/services/entry/data/offlineEntries';
import { Entry } from 'src/services/entry/Entry';
import { EntryService } from 'src/services/entry/entry.service';
import { offlineEntriesLastMonth } from './data/offlineEntriesLastMonth';
import { offlineEntriesVacation } from './data/offlineEntriesVacation';
import { offlineEntriesMonthBeforeLast } from './data/offlineEntriesMonthBeforeLast';

@Injectable({
  providedIn: 'root',
})
export class OfflineEntryServiceService implements EntryService {
  public entries = new BehaviorSubject<Entry[]>([]);

  private localEntries: Entry[] = [];

  constructor() {
    // this.localEntries = offlineEntries;
    this.localEntries = [
      ...offlineEntries,
      ...offlineEntriesLastMonth,
      ...offlineEntriesVacation,
      ...offlineEntriesMonthBeforeLast,
    ];
    this.entries.next(this.localEntries);
  }

  put(entry: Entry): Promise<void> {
    this.localEntries = this.localEntries.map((e) =>
      e.id === entry.id ? entry : e
    );
    this.entries.next(this.localEntries);
    return Promise.resolve();
  }

  post(entry: Entry): Promise<void> {
    this.localEntries.push({ ...entry, id: Math.random().toString() });
    this.entries.next(this.localEntries);
    return Promise.resolve();
  }

  delete(id: string): Promise<void> {
    this.localEntries = this.localEntries.filter((entry) => entry.id !== id);
    this.entries.next(this.localEntries);
    return Promise.resolve();
  }
}
